import { LogoDefault } from './LogoDefault.js';

export const LogoParksAndUnivers = (label, slug) => {
    let logo, src;
    try {
        if (label === 'park') logo = `parks/logo-${slug}.webp`;
        if (label === 'univers') logo = `univers/logo-${slug}.webp`;
        src = require(`../assets/images/logos/${logo}`);
    } catch (e) {
        console.log(e);
        src = LogoDefault();
    }
    return src;
}